import { FC } from 'react'
import { IJobBase } from '@/types'
import { JobCard } from '@components-v2/molecules/JobCard'
import styles from './index.module.scss'

type Props = {
  jobs: IJobBase[]
}

export const JobCardList: FC<Props> = ({ jobs }) => {
  return (
    <div className={styles.container}>
      {jobs?.map((job) => (
        <JobCard key={job.id} job={job} />
      ))}
    </div>
  )
}
